import React, { useState } from "react";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { LANGS } from "../../lib/constants";
import AdminDialog, { Field, DialogButtons } from "./AdminDialog";

export default function ReviewDialog({ review, user, onClose, onSaved }) {
  const [form, setForm] = useState({ rating: review?.rating || 5, text: review?.text || "", language: review?.language || user?.language || "RU" });
  const set = (k) => (e) => setForm({ ...form, [k]: k === "rating" ? Number(e.target.value) : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    const res = review
      ? await act(api.put(`/admin/reviews/${review.id}`, { rating: form.rating, text: form.text }), "Отзыв сохранён")
      : await act(api.post("/admin/reviews", { ...form, user_id: user.id }), "Отзыв добавлен");
    if (res) onSaved();
  };

  return (
    <AdminDialog title={review ? "✏️ Отзыв" : `➕ Отзыв от ${user.name}`} onClose={onClose} testid="review-dialog">
      <form onSubmit={save} className="space-y-4">
        <Field label="Оценка">
          <select value={form.rating} onChange={set("rating")} data-testid="review-rating-select">
            {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{"★".repeat(n)} ({n})</option>)}
          </select>
        </Field>
        {!review && (
          <Field label="Язык отзыва">
            <select value={form.language} onChange={set("language")} data-testid="review-language-select">
              {LANGS.map((l) => <option key={l} value={l}>{l}</option>)}
            </select>
          </Field>
        )}
        <Field label="Текст">
          <textarea rows={4} required value={form.text} onChange={set("text")} data-testid="review-text-input" />
        </Field>
        <DialogButtons onClose={onClose} testid="review" />
      </form>
    </AdminDialog>
  );
}
